import {Component, OnInit} from '@angular/core';
import {ParametrizacionEmpleadoService} from "../../services/parametrizacion-empleado.service";
import {LfsaBotonsGridComponent} from "../../../../shared/components/lfsa-botons-grid/lfsa-botons-grid.component";
import {moduloHorasExtras} from "../../diccionarios/horas-extrasModulo";
import {ModalService} from "../../services/modal.service";
import {SessionStorageService} from "../../../../shared/utils/session-storage.service";

@Component({
  selector: 'app-modal-empleado',
  templateUrl: './modal-empleado.component.html',
  styleUrls: ['./modal-empleado.component.css']
})
export class ModalEmpleadoComponent implements OnInit {

  listaVaciaEmpleados: boolean = true;
  loadingEmpleados: boolean = false;
  frameworkComponentsEmpleados: any;
  rowDataEmpleados: any[] = [];
  columnDefsEmpleados: any[];
  rowSelectionEmpleados: any;
  modulo: any = {};
  gridApiEmpleados: any;
  cmbEmpleados: any[] = [];
  gridColumnApiEmpleados: any;
  inputInformation: any;

  constructor(private _parametrizacionEmpleadoService: ParametrizacionEmpleadoService, private _modalService: ModalService,
              private _sessionStorageService: SessionStorageService) {
  }

  ngOnInit(): void {
    this.modulo = moduloHorasExtras;
    this.girdComponent();
    this.getAllEmpleado();
    this._modalService.getModalInputInformation().subscribe(data => {
      if (data) {
        this.inputInformation = data;
      }
    });
  }

  onGridReadyProveedores(params) {
    this.gridApiEmpleados = params.api;
    this.gridColumnApiEmpleados = params.column
  }

  girdComponent() {
    this.columnDefsEmpleados = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.setEmpleadoSelecction.bind(this),
          classBtn: 'btn btn-info btn-block',
          iconBtn: 'fa fa-check',
          tooltipMensaje: 'Seleccionar Empleado'
        }
      },
      {
        headerName: 'CÓDIGO',
        field: 'codEmpleado',
        sortable: true,
        filter: true,
        width: 120,
        floatingFilter: true
      },
      {
        headerName: 'NOMBRE',
        field: 'nombres',
        sortable: true,
        filter: true,
        width: 310,
        floatingFilter: true
      }
    ];
    this.frameworkComponentsEmpleados = {
      buttonRenderer: LfsaBotonsGridComponent,
    };
    this.rowSelectionEmpleados = 'single';
  }

  getAllEmpleado() {
    this.loadingEmpleados = true;
    if (this._sessionStorageService.getSessionStorage('empleadosList')) {
      this.rowDataEmpleados = this._sessionStorageService.getSessionStorage('empleadosList');
      this.loadingEmpleados = false;
      this.listaVaciaEmpleados = this.rowDataEmpleados.length === 0 ? true : false;
    } else {
      this._parametrizacionEmpleadoService.getAllEmpleados().subscribe((res: any[]) => {
        this.rowDataEmpleados = res;
        this.loadingEmpleados = false;
        this.listaVaciaEmpleados = this.rowDataEmpleados.length === 0 ? true : false;
        this._sessionStorageService.setSessionStorage('empleadosList', this.rowDataEmpleados);
      }, (err) => {
        this.rowDataEmpleados = [];
        this.loadingEmpleados = false;
        this.listaVaciaEmpleados = true;
      });
    }
  }

  setEmpleadoSelecction({rowData}) {
    const empleado: any = rowData;
    this.cmbEmpleados = [];
    this.cmbEmpleados.push(empleado);
    const payloadEvent = {
      action: 'close',
      data: empleado,
      inputInformation: this.inputInformation
    }
    this._modalService.setModalEvent(payloadEvent);
  }

}
